import {ImportingDataTypes} from "../../types";
import {
    createBooleanField,
    createFormAutocompleteField,
    createInvalidFormSection,
    createInvalidPartSection,
    PreventionInvalidityCode,
    PreventativeAutocompleteType,
} from "./shared";

export const preventativeInteraction = {
    datasourceId: ImportingDataTypes.productFormAssignment,
    sections: [
        createInvalidPartSection("partNumber"),
        createInvalidFormSection("formTitle"),
        {
            sectionKey: "invalidIsRequiredToFill",
            sectionTitle: "Invalid Is Required to Fill Values",
            invalidityCode: PreventionInvalidityCode.INVALID_BOOLEAN,
            fields: [
                {
                    key: "partNumber",
                    label: "Part Number",
                    type: "text",
                    extractValue: (o) => (typeof o === "string" ? o : o?.partNo ?? null),
                    modifyRow: (row, val) => ({...row, partNumber: val}),
                },
                {
                    key: "formTitle",
                    label: "Form Title",
                    type: "text",
                    extractValue: (o) => (typeof o === "string" ? o : o?.title ?? null),
                    modifyRow: (row, val) => ({...row, formTitle: val}),
                },
                createBooleanField("isRequiredToFill", "Is Required to Fill"),
            ],
        },
        {
            sectionKey: "missingProductFormFields",
            sectionTitle: "Missing Required Fields",
            invalidityCode: PreventionInvalidityCode.MISSING_REQUIRED_FIELDS,
            fields: [
                {
                    key: "partNumber",
                    label: "Part Number",
                    type: PreventativeAutocompleteType.PART,
                    extractValue: (o) => (typeof o === "string" ? o : o?.partNo ?? null),
                    modifyRowUsesPatchValue: true,
                    modifyRow: (row, val) => ({
                        ...row,
                        partNumber: typeof val === "string" ? val : val?.partNo ?? val,
                    }),
                    autocompleteProps: {
                        placeholder: "Search for part...",
                        getOptionLabel: (o) => o?.partNo ?? "",
                        isOptionEqualToValue: (o, v) => o?.partNo === v?.partNo,
                    },
                },
                createFormAutocompleteField("formTitle"),
                createBooleanField("isRequiredToFill", "Is Required to Fill"),
            ],
        },
    ],
};
